import { masterDetailsMinHeight, pageBgColor } from "@/utils/theme";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { WaterBills } from "./components/WaterBills";
import {
	UTILITY_CONSUMPTION_UTILITY,
	UtilityConsumptionUtility,
} from "../report/models/UtilityConsumption";
import { ConsumptionUtilityTabs } from "../report/components/ConsumptionFilterBar";
import { WipState } from "../report/components/ConsumptionStates";

export const UtilityManagementPage = () => {
	const [utility, setUtility] = useState<UtilityConsumptionUtility>(
		UTILITY_CONSUMPTION_UTILITY.WATER,
	);

	return (
		<>
			<HelmetDexteel title="Utility Management" />
			<Box
				sx={{
					bgcolor: pageBgColor,
					boxSizing: "border-box",
					display: "flex",
					flexDirection: "column",
					height: { lg: "calc(100vh - 100px)" },
					minHeight: { lg: "calc(100vh - 100px)" },
					p: { xs: 1, md: 2 },
				}}
			>
				<Typography
					component="h1"
					sx={{
						fontSize: "1.5rem",
						fontWeight: 600,
						lineHeight: 1.25,
						mb: 1,
					}}
				>
					Utility Management
				</Typography>
				<ConsumptionUtilityTabs
					utility={utility}
					onUtilityChange={setUtility}
				/>
				{utility !== UTILITY_CONSUMPTION_UTILITY.WATER ? (
					<WipState utility={utility} />
				) : (
					<WaterBills />
				)}
			</Box>
		</>
	);
};
